class ClassWatcher {

    constructor(targetNode, classToWatch, classAddedCallback, classRemovedCallback) {
        this.targetNode = targetNode
        this.classToWatch = classToWatch
        this.classAddedCallback = classAddedCallback
        this.classRemovedCallback = classRemovedCallback
        this.observer = null
        this.lastClassState = targetNode.classList.contains(this.classToWatch)

        this.init()
    }

    init() {
        this.observer = new MutationObserver(this.mutationCallback)
        this.observe()
    }

    observe() {
        this.observer.observe(this.targetNode, { attributes: true })
    }

    disconnect() {
        this.observer.disconnect()
    }

    mutationCallback = mutationsList => {
        for(let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                let currentClassState = mutation.target.classList.contains(this.classToWatch)
                if(this.lastClassState !== currentClassState) {
                    this.lastClassState = currentClassState
                    if(currentClassState) {
                        this.classAddedCallback()
                    }
                    else {
                        this.classRemovedCallback()
                    }
                }
            }
        }
    }
}


function drawPoketier(card,bg,name,hp,at1,at2,desc,canvasName)
{
  
  var font = new FontFaceObserver('gillsans');

font.load().then(function () {
  
  var c=document.getElementById(canvasName);
  c.style.letterSpacing ="0px";
	var ctx=c.getContext("2d");
	var imageObj1 = new Image();
	var imageObj2 = new Image();
  
  	 ctx.fillStyle = "black";

  
  if(card == 1)
  {
    	imageObj1.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/wasser.jpg?v=1622813472"

  }
  else if(card == 2)
  {
    	imageObj1.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/normal.jpg?v=1622813472"

  }
  else if(card == 3)
  {
    	imageObj1.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/elektrisch.jpg?v=1622813472"

  }
  else if(card == 4)
  {
    	imageObj1.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/feuer.jpg?v=1622813472"

  }
  else if(card == 5)
  {
    	imageObj1.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/grass.jpg?v=1622813472"

  }
  else if(card == 6)
  {
    	imageObj1.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/finsternis.jpg?v=1622813472"
        	 ctx.fillStyle = "white";


  }
  else if(card == 7)
  {
    	imageObj1.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/psycho.jpg?v=1622813473"

  }
  else
  {
        	imageObj1.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/kampf.jpg?v=1622813472"

  }
  
	imageObj1.onload = function() {
	   ctx.drawImage(imageObj1, 0, 0, 500, 750);
	   
      if(bg == 1)
      {
        imageObj2.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/canyon1.jpg?v=1622888915";
      }
      else if(bg == 2)
      {
                imageObj2.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/cave1.jpg?v=1622888915";

      }
      else if(bg == 3)
      {
                imageObj2.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/beach1.jpg?v=1622888914";

      }
      else if(bg == 4)
      {
                imageObj2.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/field1.jpg?v=1622888915";

      }
      else if(bg == 5)
      {
                imageObj2.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/forest1.jpg?v=1622888914";

      }
      else if(bg == 6)
      {
                imageObj2.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/glacier1.jpg?v=1622888914";

      }
      
      
      
	   imageObj2.onload = function() {
		  ctx.drawImage(imageObj2, 57.52, 93.4, 385, 293);

         
         
         
         
         if(name.length < 12)
         {
	           ctx.font = "30pt gillsans";

         }
         else if(name.length >= 12 && at1.length < 16)
         {
	            ctx.font = "24pt gillsans";

           
         }
         else
         {
                      	ctx.font = "20pt gillsans";

         }
         
         
         
		ctx.fillText(name,48,72);
         
         
         var font = new FontFaceObserver('gillsansreg');

font.load().then(function () {
         
         var x = 338;
         var nn;
         	           ctx.font = "30pt gillsansreg";

         
         if(hp.length > 3)
         {
            
           nn = hp.length - 3;
           x = 343 - (nn * 20);
         }
         
         ctx.fillText(hp,x,72);
         
         	ctx.font = "12pt gillsans";
         
         ctx.fillText("HP",x-20,72);


         
         if(at1.length < 8)
         {
           	ctx.font = "600 32px gillsansreg";

         }
         else if(at1.length >= 8 && at1.length < 16)
         {
                      	ctx.font = "600 32px gillsansreg";

           
         }
         else
         {
                      	ctx.font = "600 22px gillsansreg";

         }


		ctx.fillText(at1,148,478);
         
         
          if(at2.length < 8)
         {
           	ctx.font = "600 32px gillsansreg";

         }
         else if(at2.length >= 8 && at2.length < 16)
         {
                      	ctx.font = "600 32px gillsansreg";

           
         }
         else
         {
                      	ctx.font = "600 22px gillsansreg";

         }
         
		ctx.fillText(at2,148,570);

	ctx.font = "18px gillsansreg";

	//Implement function to do a linebreak after X characters



	var first;
	var second;

			if(desc.length >= 55)
			{
				first = desc.substring(0,55);
				second = desc.substring(55,desc.length);
				console.log("Zu lang!");
				console.log (first);
				console.log(second);

				ctx.fillText(first,58,682);


				ctx.fillText(second,58,697);



			}
			else
			{

				ctx.fillText(desc,58,682);

			}

		



		  var img = c.toDataURL("image/png");


		  document.write('<img src="' + img + '" width="500" height="750"/>');
  });
	   }
	};
                 
                 
  
  
  
  
  
});
  
  
  
	

}

function drawTrainer(bg,name,desc,canvasName)
{
  
   var font = new FontFaceObserver('gillsans');

font.load().then(function () {
  
  var c=document.getElementById(canvasName);
  c.style.letterSpacing ="0px";
	var ctx=c.getContext("2d");
	var imageObj1 = new Image();
	var imageObj2 = new Image();
  
  	 ctx.fillStyle = "black";

  
  
    imageObj1.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/trainerkarte.jpg?v=1624200735"

  
  
	imageObj1.onload = function() {
	   ctx.drawImage(imageObj1, 0, 0, 500, 750);
	   
      if(bg == 1)
      {
        imageObj2.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/canyon_tpreview.jpg?v=1624200971";
      }
      else if(bg == 2)
      {
                imageObj2.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/cave_tpreview.jpg?v=1624326911";

      }
      else if(bg == 3)
      {
                imageObj2.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/beach_tpreview.jpg?v=1624326911";

      }
      else if(bg == 4)
      {
                imageObj2.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/field_tpreview.jpg?v=1624326911";

      }
      else if(bg == 5)
      {
                imageObj2.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/forest_tpreview.jpg?v=1624326911";

      }
      else if(bg == 6)
      {
                imageObj2.src = "https://cdn.shopify.com/s/files/1/0398/9988/9821/files/glacier_tpreview.jpg?v=1624326911";

      }
      
      
      
	   imageObj2.onload = function() {
		  ctx.drawImage(imageObj2, 45.32, 173.4, 411, 231);

         
         
         
         
         if(name.length < 12)
         {
	           ctx.font = "30pt gillsans";

         }
         else if(name.length >= 12 && at1.length < 16)
         {
	            ctx.font = "24pt gillsans";

           
         }
         else
         {
                      	ctx.font = "20pt gillsans";

         }
         
         
         
		ctx.fillText(name,48,150);
         
         
         var font = new FontFaceObserver('gillsans');

font.load().then(function () {
         
         var x = 338;
         var nn;
        

	ctx.font = "22px gillsans";

	//Implement function to do a linebreak after X characters



	var first;
	var second;
  var third;
  var fourth;
  var fifth;
  var sixt;
  var seventh;

			if(desc.length >= 37 && desc.length < 74)
			{
				first = desc.substring(0,37);
				second = desc.substring(37,desc.length);
				console.log("Zu lang!");
				console.log (first);
				console.log(second);

				ctx.fillText(first,75,482);


				ctx.fillText(second,75,502);



			}
  			else if(desc.length >= 74 && desc.length < 111)
            {
              first = desc.substring(0,37);
				second = desc.substring(37,74);
              third = desc.substring(74);
              ctx.fillText(first,75,482);


				ctx.fillText(second,75,502);
              				ctx.fillText(third,75,522);

              
              
            }
  			else if(desc.length >= 111 && desc.length < 148)
            {
              first = desc.substring(0,37);
				second = desc.substring(37,74);
              third = desc.substring(74, 111);
              fourth = desc.substring(111);
              ctx.fillText(first,75,482);


				ctx.fillText(second,75,502);
              				ctx.fillText(third,75,522);
                            				ctx.fillText(fourth,75,542);


              
              
            }
  else if(desc.length >= 148 && desc.length < 185)
            {
              first = desc.substring(0,37);
				second = desc.substring(37,74);
              third = desc.substring(74, 111);
              fourth = desc.substring(111, 148);
              fifth = desc.substring(148);
              ctx.fillText(first,75,482);


				ctx.fillText(second,75,502);
              				ctx.fillText(third,75,522);
                            				ctx.fillText(fourth,75,542);
                                          				ctx.fillText(fifth,75,562);



              
              
            }
  else if(desc.length >= 185 && desc.length < 201)
            {
              first = desc.substring(0,37);
				second = desc.substring(37,74);
              third = desc.substring(74, 111);
              fourth = desc.substring(111, 148);
              fifth = desc.substring(148,185);
              sixt = desc.substring(185);
              ctx.fillText(first,75,482);


				ctx.fillText(second,75,502);
              				ctx.fillText(third,75,522);
                            				ctx.fillText(fourth,75,542);
                                          				ctx.fillText(fifth,75,562);
                                          				ctx.fillText(sixt,75,582);

            }
              
              
			else
			{

				ctx.fillText(desc,75,482);

			}

		



		  var img = c.toDataURL("image/png");


		  document.write('<img src="' + img + '" width="500" height="750"/>');
  });
	   }
	};
                 
                 
  
  
  
  
  
});
  
  
  
}
